import { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, Tag, message } from "antd";
import ticketService from "../services/ticketService";
import { toast } from 'react-toastify';

const { TextArea } = Input;
const { Option } = Select;

const Tickets = () => {
  const [tickets, setTickets] = useState([]);
  // Removed unused ticketTypes state
  const [ticketStatuses, setTicketStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  // Removed unused form from Form.useForm()

  const fetchData = async () => {
    setLoading(true);
    try {
      const [ticketList,  statusList] = await Promise.all([
        ticketService.getAllTickets(),
        ticketService.getAllTicketTypes(),
        ticketService.getAllTicketStatuses()
      ]);
      setTickets(ticketList);
      // Removed setTicketTypes(typeList) since ticketTypes is not used
      // If you need ticketTypes later, uncomment the state and this line
      setTicketStatuses(statusList);
    } catch {
      message.error("Veriler alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (ticketId, statusId) => {
    try {
      const response = await ticketService.changeTicketStatus(ticketId, statusId);
      if (response?.Status) {
        toast.success("Durum başarıyla güncellendi.");
        fetchData();
      } else {
        toast.error(response?.Message || "Durum güncellenemedi.");
      }
    } catch (error) {
      toast.error("Durum güncellenirken hata oluştu.");
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      'Yeni': 'blue',
      'İşlemde': 'orange',
      'Çözüldü': 'green',
      'Kapatıldı': 'default',
      'Beklemede': 'purple'
    };
    return colors[status] || 'default';
  };

  const showTicketDetail = (record) => {
    setSelectedTicket(record);
    setIsDetailModalOpen(true);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <h2>Destek Talepleri</h2>
      
      <Table
        rowKey="id"
        loading={loading}
        dataSource={tickets}
        columns={[
          { 
            title: "Açıklama", 
            dataIndex: "description",
            ellipsis: true,
            width: '35%'
          },
          { 
            title: "Kullanıcı", 
            dataIndex: ["createUserId"],
            width: '15%',
            render: (userId) => userId ? `Kullanıcı ${userId.substring(0, 8)}...` : '-'
          },
          { 
            title: "Tip", 
            dataIndex: ["ticketTypeDto", "name"],
            width: '10%'
          },
          { 
            title: "Durum", 
            dataIndex: ["ticketStatusDto", "name"],
            width: '10%',
            render: (status) => (
              <Tag color={getStatusColor(status)}>{status}</Tag>
            )
          },
          {
            title: "Oluşturma Tarihi",
            dataIndex: "createTime",
            width: '10%',
            render: (date) => new Date(date).toLocaleDateString('tr-TR')
          },
          {
            title: "İşlem",
            width: '20%',
            render: (text, record) => (
              <>
                <Select
                  size="small"
                  style={{ width: 120, marginRight: 8 }}
                  value={record.ticketStatusId}
                  onChange={(value) => handleStatusChange(record.id, value)}
                >
                  {ticketStatuses.map(status => (
                    <Option key={status.id} value={status.id}>
                      {status.name}
                    </Option>
                  ))}
                </Select>
                <Button
                  size="small"
                  onClick={() => showTicketDetail(record)}
                >
                  Detay
                </Button>
              </>
            ),
          },
        ]}
      />

      {/* Detay Modal */}
      <Modal
        title="Destek Talebi Detayı"
        open={isDetailModalOpen}
        onCancel={() => {
          setIsDetailModalOpen(false);
          setSelectedTicket(null);
        }}
        footer={[
          <Button key="close" onClick={() => setIsDetailModalOpen(false)}>
            Kapat
          </Button>
        ]}
        width={700}
      >
        {selectedTicket && (
          <div>
            <div style={{ marginBottom: 16 }}>
              <strong>Açıklama:</strong>
              <p style={{ 
                backgroundColor: '#f0f0f0', 
                padding: 12, 
                borderRadius: 4,
                marginTop: 8 
              }}>
                {selectedTicket.description}
              </p>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                <strong>Tip:</strong> {selectedTicket.ticketTypeDto?.name}
              </div>
              <div>
                <strong>Durum:</strong> 
                <Tag color={getStatusColor(selectedTicket.ticketStatusDto?.name)} style={{ marginLeft: 8 }}>
                  {selectedTicket.ticketStatusDto?.name}
                </Tag>
              </div>
              <div>
                <strong>Oluşturma Tarihi:</strong> {new Date(selectedTicket.createTime).toLocaleString('tr-TR')}
              </div>
              <div>
                <strong>Kullanıcı ID:</strong> {selectedTicket.createUserId}
              </div>
            </div>

            {/* Admin Notu Bölümü (opsiyonel - ileride eklenebilir) */}
            <div style={{ marginTop: 24 }}>
              <strong>Admin Notları:</strong>
              <TextArea 
                rows={4} 
                placeholder="Destek talebi ile ilgili notlarınızı buraya yazabilirsiniz..."
                style={{ marginTop: 8 }}
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Tickets;